import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { IRootState, AppDispatch } from '../core/services/store';

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useAppSelector : TypedUseSelectorHook<IRootState> = useSelector;